// eslint-disable-next-line no-unused-vars
import * as React from "react";
import { Box, Typography, alpha, styled } from "@mui/material";
import { SvgBubbleTipLeft, SvgBubbleTipRight } from "../../../../shared/icons";

export const Message = styled(Box)<{ message: "true" | "false" }>`
    display: flex;
    flex-direction: column;
    justify-content: ${({ message }) => (message === "true" ? "flex-end" : "flex-start")};
`;

export const MessageBox = styled(Box)<{ message: "true" | "false" }>(
    ({ theme, message }) => `
    background: ${message === "true"
        ? alpha(
            theme.palette.primary.main,
            theme.palette.action.selectedOpacity
        )
        : theme.palette.action.hover};
    padding: .5rem 1rem;
    border-radius: ${message === "true" ? "4px 0 4px 4px" : "0 4px 4px 4px"};
    min-width: 200px;
    position: relative;
    margin: ${message === "true" ? "0 .5rem 0 0" : "0 0 0 .5rem"};
    white-space: break-spaces;
    word-wrap: break-word;
    align-self: ${message === "true" ? "flex-end" : "flex-start"};
    width: 100%;
`);

export const MessageTipLeft = styled(SvgBubbleTipLeft)(
    ({ theme }) => `
    left: -9px;
    top: 0;
    position: absolute;
    color: ${theme.palette.action.hover};
`);

export const MessageTipRight = styled(SvgBubbleTipRight)(
    ({ theme }) => `
    right: -9px;
    top: 0;
    position: absolute;
    color: ${alpha(
        theme.palette.primary.main,
        theme.palette.action.selectedOpacity
    )};
`);

export const AttachmentTitle = styled(Typography)`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 4px;
`;
